(function () {
  function shouldOpenInNewTab(href) {
    if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("javascript:")) {
      return false;
    }

    try {
      const url = new URL(href, window.location.origin);

      if (url.origin !== window.location.origin) {
        return true;
      }

      return url.pathname.includes("/pages/") || url.pathname.includes("/blogs/");
    } catch {
      return false;
    }
  }

  function applyExternalLinkTargets() {
    document.querySelectorAll("a[href]:not([target])").forEach((link) => {
      if (!shouldOpenInNewTab(link.getAttribute("href"))) {
        return;
      }

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyExternalLinkTargets);
  } else {
    applyExternalLinkTargets();
  }

  document.addEventListener("facet:update", applyExternalLinkTargets);
  document.addEventListener("shopify:section:load", applyExternalLinkTargets);
})();
